import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45bot_45or_45user_45global from "/app/middleware/01.botOrUser.global.ts";
import auth_45global from "/app/middleware/auth.global.ts";
import city_45domain_45redirect_45global from "/app/middleware/cityDomainRedirect.global.ts";
import redirect_45from_45not_45found_45global from "/app/middleware/redirectFromNotFound.global.ts";
import redirect_45to_45new_45category_45global from "/app/middleware/redirectToNewCategory.global.ts";
import redirect_45to_45new_45product_45global from "/app/middleware/redirectToNewProduct.global.ts";
import redirect_45to_45trailing_45slash_45global from "/app/middleware/redirectToTrailingSlash.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45bot_45or_45user_45global,
  auth_45global,
  city_45domain_45redirect_45global,
  redirect_45from_45not_45found_45global,
  redirect_45to_45new_45category_45global,
  redirect_45to_45new_45product_45global,
  redirect_45to_45trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}